import {
  EDIT_LEGAL_DATA,
  EDIT_LEGAL_DATA_ERROR,
  CLEAN_EDIT_LEGAL_DATA,
  CLEAN_EDIT_LEGAL_DATA_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function editLegalDataReducer(state = initialState, action) {
  switch (action.type) {
    case EDIT_LEGAL_DATA:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case EDIT_LEGAL_DATA_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_EDIT_LEGAL_DATA:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_EDIT_LEGAL_DATA_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
